class Declaracao{
    constructor(){
        this.anexos = [];
    }
}

export default Declaracao
